export default {"src":"/_next/static/media/doc.23febe20.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};